import { Box, MetaFieldGroupBy } from '@frameio/vapor';
import type { ThemeColorsMetaIcon } from '@frameio/vapor-theme';

type ToggleFieldMatchProps = {
  value: boolean;
  color?: ThemeColorsMetaIcon;
};

export const ToggleFieldMatch = ({
  value,
  color = 'default',
}: ToggleFieldMatchProps) => {
  return (
    <Box
      alignItems="center"
      display="flex"
      height={24}
      justifyContent="center"
      paddingY={2}
      width={24}
    >
      <MetaFieldGroupBy.Toggle color={color} label="" value={value} />
    </Box>
  );
};
